import { render, staticRenderFns } from "./EmailTemplateFilterToolbar.vue?vue&type=template&id=640ef85f"
import script from "./EmailTemplateFilterToolbar.vue?vue&type=script&lang=js"
export * from "./EmailTemplateFilterToolbar.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplateFilterToolbar.vue?vue&type=style&index=0&id=640ef85f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports